module.exports = __webpack_public_path__ + "static/media/picto-speech-bubble-black.437fcde8.svg";